import React from "react";
import { Link } from "react-router-dom";
import Logo from "../assets/img/logo-1.png";

const Footer = () => {
  return (
    <div className="footer">
      <h2>Intéréssé & Besoin d'un devis ?</h2>
      <p>
        Artisan peintre indépedant, je donne vie à vos idées avec soin,
        précision et créativité
      </p>
      <Link to={"/contact"} className="btn">
        Contactez-moi
      </Link>

      <div className="footer-links">
        <div className="footer-logo">
          <Link to="/">
            <img src={Logo} alt="logo LM Couleurs" />
          </Link>
        </div>
        <div className="footer-nav-links">
          <Link to={"/"}>Accueil</Link>
          <Link to={"/services"}>Services</Link>
          <Link to={"/realisations"}>Réalisations</Link>
          <Link to={"/faq"}>FAQ</Link>
          <Link to={"/contact"}>Contact</Link>
        </div>
      </div>
      <div className="footer-rgpd">
        <div className="footer-rgpd-links">
          <Link to={"/politique-de-confidentialite"}>
            Politique de confidentilité
          </Link>
          <Link to={"/mentions-legales"}>Mentions légales</Link>
        </div>
        <p>© 2025 LM Couleurs. Tous droits réservés</p>
      </div>
    </div>
  );
};

export default Footer;
